import { render, staticRenderFns } from "./chmap.vue?vue&type=template&id=521897d9&"
import script from "./chmap.vue?vue&type=script&lang=js&"
export * from "./chmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports